import type { Middleware } from 'openapi-fetch';

const UNPROTECTED_ROUTES = ['/token', '/signup'];

const NewAuthMiddleware = (accessToken: string): Middleware => {
  accessToken.length == 0 && console.error("Emtpy access token passed to Middleware");
  return {
    async onRequest({ schemaPath, request }) {
      // dont add auth on protected routes
      if (UNPROTECTED_ROUTES.some((pathname) => schemaPath.startsWith(pathname))) {
        return undefined;
      }

      request.headers.set("Authorization", `Bearer ${accessToken}`);
      return request;
    }
  };
};

export default NewAuthMiddleware;
